import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'

export function useGetCollectionCols() {
  const { loginConfig } = useUserContext()
  return useMemo(() => {
    return [
      {
        flex: 2,
        headerName: 'Holding',
        field: 'HoldingID',
        valueFormatter: (value) =>
          getCodeSetLabelLookup(loginConfig, ['KV-Holdings'], value),
      },
      {
        flex: 1,
        headerName: 'Collection ID',
        field: 'ScreenCollectionID',
      },
      {
        flex: 1,
        headerName: 'Parent Vessel ID',
        field: 'ParentVesselID',
      },
      {
        flex: 1,
        headerName: 'Sample ID',
        field: 'SampleID',
      },
      {
        flex: 1,
        headerName: 'Rack ID',
        field: 'RackID',
      },
      {
        flex: 1,
        headerName: 'Collection Date',
        field: 'Date',
      },
      {
        flex: 2,
        headerName: 'Sample Type',
        field: 'SampleType',
        renderCell: ({ value }: any) =>
          getCodeSetLabelLookup(loginConfig, ['SampleRunTypeID'], value),
      },
      {
        flex: 1,
        headerName: 'Result',
        field: 'Result',
        renderCell: ({ value }: any) =>
          getCodeSetLabelLookup(loginConfig, ['ResultID'], value),
      },
      {
        flex: 3,
        headerName: 'Status',
        field: 'Status',
        renderCell: ({ value }: any) =>
          getCodeSetLabelLookup(loginConfig, ['SampleStatusID'], value),
      },
    ] as GridColDef[]
  }, [loginConfig])
}
